import { ErrorHandler } from '@angular/core';

import { ErrorHandlerService } from './error-handler.service';

export function createErrorHandlerFactory(errorHandler?: ErrorHandler): () => ErrorHandler {
	return () => new ErrorHandlerService(errorHandler);
}
